export default __webpack_public_path__ + "static/media/Myracle tutorial_v1.0_ES_low quality.c9712706.mp4";